module.exports = __webpack_public_path__ + "img/winerackdog22.9737ba87.jpg";